import { Controller } from '@hotwired/stimulus'
import flatpickr from 'flatpickr'

// Wraps Flatpickr (https://flatpickr.js.org) for the design system's
// date/time picker component. Supports date, time, datetime and range modes,
// plus an optional clear action.
//
// Usage (controller goes on the wrapper so a sibling clear button can target it):
//   .relative{ data: { controller: 'datepicker' } }
//     %input{ data: { datepicker_target: 'input' } }
//     %button{ data: { action: 'datepicker#clear' } } Clear
export default class extends Controller {
  static targets = ['input']
  static values = {
    mode: { type: String, default: 'single' }, // single | multiple | range
    enableTime: Boolean,
    noCalendar: Boolean,
    dateFormat: String,
    altFormat: String,
    placeholder: String,
    defaultDate: String
  }

  connect() {
    const options = {
      mode: this.modeValue,
      enableTime: this.enableTimeValue,
      noCalendar: this.noCalendarValue,
      dateFormat: this.dateFormatValue,
      placeholder: this.placeholderValue,
      defaultDate: this.defaultDateValue,
      // Re-dispatch flatpickr's change as a native change event on the input,
      // so forms can react with `data-action="change->..."` (e.g. the async
      // customers quick search) and the clear button triggers it too.
      onChange: () => {
        this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }))
      }
    }

    // altInput shows a friendly format while the hidden input stores the
    // machine-readable dateFormat value (handy for time mode).
    if (this.hasAltFormatValue) {
      options.altInput = true
      options.altFormat = this.altFormatValue
    }

    this.instance = flatpickr(this.inputTarget, options)
  }

  clear() {
    this.instance?.clear()
  }

  disconnect() {
    this.instance?.destroy()
  }
}
